/*global define*/

define([
    'jquery',
    'underscore',
    'backbone',
    'd3',
    'chemistry/SpecieState',
    'dygraphs',
    'processing',
    'tinycolor',
    '../resources/lang'
], function ($, _, Backbone, d3, SpecieState, Dygraph, processing, tinycolor, lang) {
    'use strict';

    var InstrumentpanelView = Backbone.View.extend({
        events: {
            'click .infoChoice': 'changeInfoChoice',
            'click #trackVessel': 'openTrackingOptions',
            'click #startTracking': 'startTracking',
            'click .spectrometerChoice': 'changeSpectrometerChoice',
            // 'click #viewerMenu': 'openMenu',
            //'click .viewerMenuItem': 'toggleViewer'
        },
        template: require('ejs-loader!../templates/InstrumentPanel.ejs'),
        render: function(){
        	this.$el.html(this.template({
                assignmentTitle: this.assignmentTitle,
                assignmentText: this.assignmentText,
                vessel: this.vessel,
                spectrometerChoice: this.spectrometerChoice,
                terms: _.extend({}, lang.instrumentPanel, lang.spectrometer),
                language: language
            }));
            $("#instrumentPanelContainer").scrollTop(this.scrollTop);
            if (this.vessel) {
                var i;
                for (i = this.viewerList.length - 1; i >= 0; i--) {
                    var viewer = $("#" + this.viewerList[i]);
                    viewer.parent().prepend(viewer);
                    $(".viewerList").prepend('<li><a title="' + this.viewerList[i] + '" class="viewerMenuItem">' + this.viewers[this.viewerList[i]].name + '<span class="glyphicon glyphicon-ok"></span></a></li>');
                }
                $(".viewerMenuItem").on("click", this.toggleViewer.bind(this));
            }
        },
        initialize: function(){
            this.scrollTop = 0;
            this.vessel = undefined;
            this.spectrometerChoice = "graph";
            this.calculatedAbsorbance = "";
            this.p = null;
            this.intervals = {};
            this.viewers = {
                assignment: {
                    display: "none",
                    name: lang.viewers.assignment[language]
                },
                solutionProperties: {
                    display: "none",
                    name: lang.viewers.solutionProperties[language]
                },
                thermometer: {
                    display: "none",
                    name: lang.viewers.thermometer[language]
                },
                pH: {
                    display: "none",
                    name: lang.viewers.pH[language]
                },
                aqueous: {
                    display: "none",
                    name: lang.viewers.aqueous[language]
                },
                solid: {
                    display: "none",
                    name: lang.viewers.solid[language]
                },
                gas: {
                    display: "none",
                    name: lang.viewers.gas[language]
                },
                conductivity: {
                    display: "none",
                    name: lang.viewers.solutionProperties[language]
                },
                spectrometer: {
                    display: "none",
                    name: lang.viewers.spectrometer[language]
                },
                particleView: {
                    display: "none",
                    name: lang.viewers.particleView[language]
                },
                vesselTrackingControl: {
                    display: "none",
                    name: lang.viewers.vesselTrackingControl[language]
                }
            };
            this.viewerList = [];
            this.assignmentTitle = "";
            this.assignmentText = "";
            this.name = "";
            this.volume = 0;
            this.temperature = 273.15;
            this.pH = 7;
            this.aqueousUnits = "Molarity";
            this.solidUnits = "grams";
            this.gasUnits = "atm";
            this.render();
        },
        open: function(){
            $("#instrumentPanelContainer").removeClass("instrumentPanelClosed");
            $("#instrumentPanelContainer").css("display", "block");
            $("#instrumentPanelHeader").addClass("selected");
        },
        close: function(){
            this.frozen = true;
            if (this.p !== null) {
                this.p.exit();
            }
            $("#instrumentPanelContainer").addClass("instrumentPanelClosed");
            $("#instrumentPanelContainer").css("display", "none");
            $("#instrumentPanelHeader").removeClass("selected");
        },
        update: function(vessel){
            this.scrollTop = $("#instrumentPanelContainer").scrollTop();
            if (vessel === undefined) {
                this.vessel = vessel;
                this.render();
            }
            else {
                if (vessel !== this.vessel || Math.abs(vessel.get("temperature") - this.temperature) >= 1 || vessel.get("volume") !== this.volume) {
                    this.frozen = false;
                }
                if (this.vessel === undefined) {
                    this.vessel = vessel;
                    this.render();
                }
                this.name = vessel.attributes.name;
                this.volume = vessel.attributes.volume;
                this.temperature = vessel.attributes.temperature;
                this.pH = vessel.attributes.pH || 7;
                this.vessel = vessel;
                this.loadViewers();
                if (this.vessel.get("tracking")) {
                    this.loadTracking();
                }
            }
        },
        loadViewers: function(){
            $(".instrumentPanelElement").each(function(index, element){
                $(element).css("display", this.viewers[$(element).attr("id")].display);
            }.bind(this));
            $(".viewerMenuItem").each(function(index, element){
                if (this.viewers[$(element).attr("title")].display === "block") {
                    $(element).find(".glyphicon").css("display", "inline-block");
                }
                else {
                    $(element).find(".glyphicon").css("display", "none");
                }
            }.bind(this));
            if (this.viewers.assignment.display === "block") {
                $("#assignmentTitle").html(this.assignmentTitle);
                $("#assignmentText").html(this.assignmentText);
            }
            if (this.viewers.solutionProperties.display === "block") {
                $("#infoName").html(lang.solutionProperties.name[language] + ": " + this.name);
                $("#infoVolume").html(lang.solutionProperties.volume[language] + ": " + this.vessel.get("volumeString"));
            }
            if (this.viewers.thermometer.display === "block") {
                var celsius = this.temperature - 273.15;
                $("#infoTemperature").html(lang.solutionProperties.temperature[language] + ": " + celsius.toLocaleString(language, {minimumFractionDigits: 2, maximumFractionDigits: 2}) + "&deg;C");
                var temperatureBar = $("#temperatureBar");
                temperatureBar.removeClass();
                if (celsius < 24) {
                    temperatureBar.addClass("progress-bar progress-bar-info");
                }
                else if (celsius < 75) {
                    temperatureBar.addClass("progress-bar progress-bar-warning");
                }
                else {
                    temperatureBar.addClass("progress-bar progress-bar-danger");
                }
                temperatureBar.css("width", celsius + "%");
                temperatureBar.html(celsius.toLocaleString(language, {minimumFractionDigits: 2, maximumFractionDigits: 2}) + " deg");
            }
            if (this.viewers.pH.display === "block") {
                $("#pH").html("pH: " + this.pH.toLocaleString(language, {maximumFractionDigits: 2, minimumFractionDigits: 2}));
            }
            if (this.viewers.aqueous.display === "block" && !this.frozen) {
                this.drawAqueousTable(this.viewers.aqueous.args.unitsToggleEnabled);
            }
            if (this.viewers.solid.display === "block" && !this.frozen) {
                this.drawSolidTable(this.viewers.solid.args.unitsToggleEnabled);
            }
            if (this.viewers.gas.display === "block" && !this.frozen) {
                this.drawGasTable(this.viewers.gas.args.unitsToggleEnabled);
            }
            // Put the conductivity information here
            if (this.viewers.conductivity.display === "block") {
                    $("#conductivityName").html(lang.viewers.conductivity[language]);
                    const conductivity = this.vessel.get("conductivity");
                    // Round to 3 sig figs - if less that 1e-3 and greater than 0, use scientific notation
                    if (conductivity < 1e-3 && conductivity > 0) {
                        $("#conductivityValue").html(`${(conductivity).toExponential(2)} mS/cm`);
                    } else {
                    $("#conductivityValue").html(`${conductivity.toPrecision(3)} mS/cm`);
                    }
                }
            if (this.viewers.spectrometer.display === "block" && !this.frozen) {
                this.drawSpectrometerTable();
            }
            if (this.viewers.particleView.display === "block" && !this.frozen) {
                this.drawParticleView();
            }
            if (this.viewers.vesselTrackingControl.display === "block") {

            }
        },

        changeSpectrometerChoice: function(clicked){
            this.spectrometerChoice = $(clicked.currentTarget).attr("id");
            this.frozen = false;
            this.render();
        },
        /*drawSpeciesChart: function(){

            $("#speciesChartSvg").html("");

            if (this.vessel === undefined){
                return
            }

            var spc = this.vessel.get("species");
            var data = $.extend(true, spc, {});


            var log10 = function (amt){
                var val = Math.log(amt + 1e-16)/Math.log(10);
                return val
            }

            var width = 200,
                barHeight = 20;

            var x = d3.scale.linear()
                .range([0, width])
                .domain([d3.min(data, function (d) { return log10(d.amount); }),
                         d3.max(data, function (d) { return log10(d.amount); })]);

            var chart = d3.select("#speciesChartSvg")
                .attr("width", width);


            chart.attr("height", barHeight * data.length);

            var bar = chart.selectAll("g")
                .data(data)
                .enter().append("g")
                .attr("transform", function(d, i) { return "translate(0," + i * barHeight + ")"; });

            bar.append("rect")
                .attr("width", function (d) { return Math.max(0, x(log10(d.amount))); })
                .attr("height", barHeight - 1)
                .attr("transform", "translate(60, 0)")
                .attr("fill", "yellowgreen");

            bar.append("text")
                .attr("class", "concLabel")
                .attr("x", function (d) { return x(log10(d.amount)) - 3; })
                .attr("y", barHeight / 2)
                .attr("dy", ".35em")
                .attr("fill", "white")
                .attr("transform", "translate(66, 0)")
                .text(function (d) { return log10(d.amount).toFixed(2); });

            bar.append("text")
                .attr("x", 10 )
                .attr("width", 40)
                .attr("y", barHeight / 2)
                .attr("dy", ".35em")
                .attr("fill", "white")
                .attr("text-anchor", "end")
                .attr("transform", "translate(40, 0)")
                .text(function(d) { return d.simpleName; });

            $("#speciesChartSvg").html(chart[0]);
        },
        redrawSpeciesChart: function (){
            var spc = this.vessel.get("species.json");
            var data = $.extend(true, spc, {});

            var chart = d3.select("#speciesChartSvg")
            var x = d3.scale.linear()
                .range([0, width])
                .domain([d3.min(data, function (d) { return d.amount; }),
                         d3.max(data, function (d) { return d.amount; })]);

            var log10 = function (amt){
                var val = Math.log(amt + 1e-16)/Math.log(10);
                return val
            }
            for (var id in data){
                data[id].amount = log10(data[id].amount)
                data[id].color = "yellowgreen"
            }

            chart.selectAll("rect")
                .data(data)
                .transition()
                .duration(100)
                .attr("width", function(d) { return x(d.amount);});

            chart.selectAll(".concLabel")
                .data(data)
                .transition()
                .duration(100)
                .attr("x", function(d) { return x(d.amount) - 3; })
                .text(function(d) { return d.amount; });
        },*/
        drawAqueousTable: function (unitsToggleEnabled){
            var species = this.vessel.get("species") || [];
            var table = $("#aqueousTable");
            if (unitsToggleEnabled) {
                table.html('<tr><th>'+lang.solutionProperties.speciesAq[language]+'</th><th class="dropdown" id="aqueousUnits"><div class="dropdown-toggle" id="aqueousUnitsToggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true" style="cursor:pointer">' + lang.units[this.aqueousUnits][language] + '<span class="caret"></span></div></th></tr>');
                $("#aqueousUnits").append('<ul class="dropdown-menu" aria-labelledby="aqueousUnitsToggle" id="aqueousUnitsList"></ul>');
                var unitsList = $("#aqueousUnitsList");
                unitsList.append('<li><a id="grams" class="aqueousUnit">'+lang.units.grams[language]+'</a></li>');
                unitsList.append('<li><a id="moles" class="aqueousUnit">'+lang.units.moles[language]+'</a></li>');
                unitsList.append('<li><a id="Molarity" class="aqueousUnit">'+lang.units.Molarity[language]+'</a></li>');
                var toggle = $("#aqueousUnitsToggle");
                toggle.unbind("click");
                toggle.on("click", function(event){
                    if (unitsList.css("display") === "none") {
                        this.frozen = true;
                        unitsList.css("display", "block");
                    }
                    else {
                        this.frozen = false;
                        unitsList.css("display", "none");
                    }
                }.bind(this));
                $(".aqueousUnit").unbind("click");
                $(".aqueousUnit").on("click", function(event){
                    this.frozen = false;
                    unitsList.css("display", "none");
                    this.aqueousUnits = $(event.target).attr("id");
                    this.drawAqueousTable(true);
                }.bind(this));
                switch (this.aqueousUnits) {
                    case "grams":
                        var i;
                        for (i = 0; i < species.length; i++) {
                            if (species[i].state === SpecieState.AQUEOUS && species[i].weight !== 0) {
                                if (species[i].unknown) {
                                    table.append("<tr><td colspan='2'>" + species[i].name + "</td></tr>");
                                }
                                else if (species[i].weight < 10e-15) {
                                    table.append("<tr><td>" + species[i].name + "</td><td>~ 0</td></tr>");
                                }
                                else {
                                    table.append("<tr><td>" + species[i].name + "</td><td>" + species[i].weight.toPrecision(6).replace(".", lang.decimal[language]) + "</td></tr>");
                                }
                            }
                        }
                        break;
                    case "moles":
                        var i;
                        for (i = 0; i < species.length; i++) {
                            if (species[i].state === SpecieState.AQUEOUS && species[i].moles !== 0) {
                                if (species[i].unknown) {
                                    table.append("<tr><td colspan='2'>" + species[i].name + "</td></tr>");
                                }
                                else if (species[i].moles < 10e-15) {
                                    table.append("<tr><td>" + species[i].name + "</td><td>~ 0</td></tr>");
                                }
                                else {
                                    table.append("<tr><td>" + species[i].name + "</td><td>" + species[i].moles.toPrecision(6).replace(".", lang.decimal[language]) + "</td></tr>");
                                }
                            }
                        }
                        break;
                    default:
                        var i;
                        for (i = 0; i < species.length; i++) {
                            if (species[i].state === SpecieState.AQUEOUS && species[i].amount !== 0) {
                                if (species[i].unknown) {
                                    table.append("<tr><td colspan='2'>" + species[i].name + "</td></tr>");
                                }
                                else if (species[i].amount < 10e-15) {
                                    table.append("<tr><td>" + species[i].name + "</td><td>~ 0</td></tr>");
                                }
                                else {
                                    table.append("<tr><td>" + species[i].name + "</td><td>" + species[i].amount.toPrecision(6).replace(".", lang.decimal[language]) + "</td></tr>");
                                }
                            }
                        }
                }
            }
            else {
                table.html("<tr><th>"+lang.solutionProperties.speciesAq[language]+"</th><th>"+lang.units.Molarity[language]+"</th></tr>");
                var i;
                for (i = 0; i < species.length; i++) {
                    if (species[i].state === SpecieState.AQUEOUS && species[i].amount !== 0) {
                        if (species[i].unknown) {
                            table.append("<tr><td colspan='2'>" + species[i].name + "</td></tr>");
                        }
                        else if (species[i].amount < 10e-15) {
                            table.append("<tr><td>" + species[i].name + "</td><td>~ 0</td></tr>");
                        }
                        else {
                            table.append("<tr><td>" + species[i].name + "</td><td>" + species[i].amount.toPrecision(6).replace(".", lang.decimal[language]) + "</td></tr>");
                        }
                    }
                }
            }
        },
        drawSolidTable: function(unitsToggleEnabled){
            var species = this.vessel.get("species") || [];
            var table = $("#solidTable");
            if (unitsToggleEnabled) {
                table.html('<tr><th>'+lang.solutionProperties.speciesS[language]+'</th><th class="dropdown" id="solidUnits"><div class="dropdown-toggle" id="solidUnitsToggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true" style="cursor:pointer">' + lang.units[this.solidUnits][language] + '<span class="caret"></span></div></th></tr>');
                $("#solidUnits").append('<ul class="dropdown-menu" aria-labelledby="solidUnitsToggle" id="solidUnitsList"></ul>');
                var unitsList = $("#solidUnitsList");
                unitsList.append('<li><a id="grams" class="solidUnit">'+lang.units.grams[language]+'</a></li>');
                unitsList.append('<li><a id="moles" class="solidUnit">'+lang.units.moles[language]+'</a></li>');
                var toggle = $("#solidUnitsToggle");
                toggle.unbind("click");
                toggle.on("click", function(event){
                    if (unitsList.css("display") === "none") {
                        this.frozen = true;
                        unitsList.css("display", "block");
                    }
                    else {
                        this.frozen = false;
                        unitsList.css("display", "none");
                    }
                }.bind(this));
                $(".solidUnit").unbind("click");
                $(".solidUnit").on("click", function(event){
                    this.frozen = false;
                    unitsList.css("display", "none");
                    this.solidUnits = $(event.target).attr("id");
                    this.drawSolidTable(true);
                }.bind(this));
                if (this.solidUnits === "moles") {
                    var i;
                    for (i = 0; i < species.length; i++) {
                        if (species[i].state === SpecieState.SOLID && species[i].moles !== 0) {
                            if (species[i].unknown) {
                                table.append("<tr><td colspan='2'>" + species[i].name + "</td></tr>");
                            }
                            else if (species[i].moles < 10e-15) {
                                table.append("<tr><td>" + species[i].name + "</td><td>~ 0</td></tr>");
                            }
                            else {
                                table.append("<tr><td>" + species[i].name + "</td><td>" + species[i].moles.toPrecision(6).replace(".", lang.decimal[language]) + "</td></tr>");
                            }
                        }
                    }
                }
                else {
                    var i;
                    for (i = 0; i < species.length; i++) {
                        if (species[i].state === SpecieState.SOLID && species[i].weight !== 0) {
                            if (!species[i].unknown) {
                                table.append("<tr><td>" + species[i].name + "</td><td>" + species[i].weight.toPrecision(6).replace(".", lang.decimal[language]) + "</td></tr>");
                            }
                            else if (species[i].weight < 10e-15) {
                                table.append("<tr><td>" + species[i].name + "</td><td>~ 0</td></tr>");
                            }
                            else {
                                table.append("<tr><td colspan='2'>" + species[i].name + "</td></tr>");
                            }
                        }
                    }
                }
            }
            else {
                table.html("<tr><th>"+lang.solutionProperties.speciesS[language]+"</th><th>"+lang.units.grams[language]+"</th></tr>");
                var i;
                for (i = 0; i < species.length; i++) {
                    if (species[i].state === SpecieState.SOLID && species[i].weight !== 0) {
                        if (species[i].unknown) {
                            table.append("<tr><td colspan='2'>" + species[i].name + "</td></tr>");
                        }
                        else if (species[i].weight < 10e-15) {
                            table.append("<tr><td>" + species[i].name + "</td><td>~ 0</td></tr>");
                        }
                        else {
                            table.append("<tr><td>" + species[i].name + "</td><td>" + species[i].weight.toPrecision(6).replace(".", lang.decimal[language]) + "</td></tr>");
                        }
                    }
                }
            }
        },
        drawGasTable: function(unitsToggleEnabled){
            const species = this.vessel.get("species") || [];
            const table = $("#gasTable");
            const tableHead = `<tr><th>${lang.solutionProperties.speciesG[language]}</th><th>${lang.units[this.gasUnits][language]}</div></th></tr>`;
            const tableRows = species.filter(s => s.state === SpecieState.GAS)
                                      .map(s => {
                                        let concDisplay = s.amount.toPrecision(6);
                                        if (s.amount < 10e-15) {
                                            concDisplay = "~0";
                                        }
                                        return `<tr><td>${s.name}</td><td>${concDisplay.replace(".", lang.decimal[language])}</td></tr>`
                                    })
                                      .join("\n");
            table.html(`${tableHead}\n${tableRows}`);
        },
        drawSpectrometerTable: function(){
            this.frozen = true;
            var abs = this.vessel.get("absorbanceTable") || [];
            var colors = this.vessel.get("colors") || [];
            var absTable = [];
            var graphContainer = $("#absorbanceGraph");
            var table = $("#absorbanceTable");
            var that = this;
            if (this.spectrometerChoice === "graph") {
                table.css("display", "none");
                var i;
                for (i = 0; i < abs.length; i++) {
                    absTable.push([(colors[i].startWavelength + colors[i].endWavelength) / 2, abs[i]]);
                }
                var sidelength = $("#instrumentPanel").width();
                var graphOptions = {
                    //title: lang.spectrometer.spectrometer[language],
                    title: "  ",
                    xlabel: lang.spectrometer.wavelength[language] + " (nm)",
                    ylabel: lang.spectrometer.absorbance[language],
                    highlightCallback: function(){
                        that.frozen = true;
                    },
                    unhighlightCallback: function(){
                        that.frozen = false;
                    },
                    labels: [lang.spectrometer.wavelength[language]+" (nm)", lang.spectrometer.absorbance[language]],
                    height: sidelength,
                    width: sidelength,
                    rightGap: 15
                };
              var absorbanceGraph = new Dygraph["default"](graphContainer[0], absTable, graphOptions);

            }
            else if (this.spectrometerChoice === "table") {
                graphContainer.css("display", "none");
                table.html("<tr><th>"+lang.spectrometer.wavelength[language]+" (nm)</th><th>"+lang.spectrometer.absorbance[language]+"</th></tr>");
                var i;
                for (i = 0; i < abs.length; i++) {
                    absTable.push([(colors[i].startWavelength + colors[i].endWavelength) / 2, abs[i]]);
                    table.append('<tr><td>'+((colors[i].startWavelength+colors[i].endWavelength)/2).toLocaleString(language)+'</td><td>'+abs[i].toLocaleString(language, {maximumFractionDigits: 3, minimumFractionDigits: 3})+'</td></tr>');
                }
            }
            var result = $("#calculatorResult");
            var wavelengthInput = $("#wavelengthInput");
            var calculateAbsorbance = function() {
                var wavelength = parseFloat(wavelengthInput.val());
                if (isNaN(wavelength)) {
                    result.toggleClass("alert-info", false);
                    result.toggleClass("alert-danger", true);
                    that.vessel.set("desiredWavelength", undefined);
                    that.calculatedAbsorbance = lang.spectrometer.invalidWavelengthMessage[language];
                    result.html(that.calculatedAbsorbance);
                }
                else if (wavelength < colors[0].startWavelength || wavelength > colors[colors.length - 1].endWavelength) {
                    result.toggleClass("alert-info", false);
                    result.toggleClass("alert-danger", true);
                    that.vessel.set("desiredWavelength", undefined);
                    var message = lang.spectrometer.wavelengthRangeMessage[language].replace("START", colors[0].startWavelength.toString()).replace("END", colors[colors.length - 1].endWavelength.toString());
                    that.calculatedAbsorbance = message;
                    result.html(that.calculatedAbsorbance);
                }
                else {
                    result.toggleClass("alert-info", true);
                    result.toggleClass("alert-danger", false);
                    that.vessel.set("desiredWavelength", wavelength);
                    that.calculatedAbsorbance = that.vessel.get("solution").getAbsorbance(wavelength).toLocaleString(language);
                    result.html(that.calculatedAbsorbance);
                }
            };
            if (wavelengthInput.val() !== "")
                calculateAbsorbance();
            var button = $("#calculateAbsorbance");
            button.on('click', calculateAbsorbance);
            wavelengthInput.keypress(function (event) {
                if (event.which == 13) {
                    event.preventDefault();
                    calculateAbsorbance();
                }
            }.bind(this));
            if (this.calculatedAbsorbance === "") {
                result.toggleClass("alert-info", false);
                result.toggleClass("alert-danger", false);
            }
            else if (isNaN(parseFloat(this.calculatedAbsorbance))) {
                result.toggleClass("alert-info", false);
                result.toggleClass("alert-danger", true);
            }
            else {
                result.toggleClass("alert-info", true);
                result.toggleClass("alert-danger", false);
            }
            var absTableWithHeading = absTable.slice();
            absTableWithHeading.unshift([[lang.spectrometer.wavelength[language]+" (nm)", lang.spectrometer.absorbance[language]]]);
            var download = $("#absorbanceTableDownload");
            download.attr("is", "csv-download");
            download.attr("table", this.formatData(absTableWithHeading));
            download.attr("data", "{{table}}");
            download.attr("download", "Absorbance Table for " + this.vessel.get("name") + ".csv");
            download.attr("href", "data:text/csv," + download.attr("table"));
        },
        drawParticleView: function(logSampleVolume){
            if (this.p !== null) {
                this.p.exit();
            }
            this.frozen = true;
            var sketch = new Processing.Sketch();
            var vessel = this.vessel;
            var logSampleVolume = logSampleVolume || vessel.get("logSampleVolume") || -22;
            vessel.set("logSampleVolume", logSampleVolume);
            var i, j;
            var width = $("#instrumentPanel").width() - 40;
            var height = width * .75;
            var solution = vessel.get("solution").clone();
            solution.filtrate();
            var spRef = solution.speciesInSolution;
            var species = [];
            this.allSpecies = this.allSpecies || [];
            for (i = 0; i < spRef.length; i++) {
                var sp = spRef[i];
                species.push({
                    name: sp.archetype.name,
                    infinite: sp.infinite,
                    n: sp.getConcentration() * 6.02e23 * Math.pow(10, logSampleVolume),
                    h: sp.archetype.hue,
                    s: sp.archetype.saturation,
                    v: sp.archetype.value
                });
                if (_.indexOf(this.allSpecies, sp.archetype.name) === -1 && !sp.infinite)
                    this.allSpecies.push(sp.archetype.name);
            }
            var tooFew = [];
            var shown = [];
            var tooMany = [];
            for (i = 0; i < species.length; i++) {
                var sp = species[i];
                if (sp.infinite || sp.n > 1000) {
                    tooMany.push(sp);
                }
                else if (sp.n < 1) {
                    tooFew.push(sp);
                }
                else {
                    shown.push(sp);
                }
            }
            var particles = [];
            for (i = 0; i < shown.length; i++) {
                var sp = shown[i];
                var particleColor = {r: 0, g: 0, b: 0};
                if (sp.h === 0 && sp.s === 0 && sp.v === 0) {
                    var grayValue = (_.indexOf(this.allSpecies, sp.name) % 4) * 255 / 4;
                    particleColor = {r: grayValue, g: grayValue, b: grayValue};
                }
                else {
                    particleColor = tinycolor({h: sp.h, s: sp.s, v: sp.v}).toRgb();
                }
                sp.color = particleColor;
                var particleShapeID = _.indexOf(this.allSpecies, sp.name) % 3;
                sp.shapeID = particleShapeID;
                for (j = 0; j < sp.n; j++) {
                    var angle = Math.random() * 2 * Math.PI;
                    particles.push({
                        x: Math.random() * width,
                        y: Math.random() * height,
                        xDirection: 2 * Math.cos(angle) * (this.temperature - 273.15) / 100.0,
                        yDirection: 2 * Math.sin(angle) * (this.temperature - 273.15) / 100.0,
                        r: 10,
                        color: particleColor,
                        shapeID: particleShapeID
                    });
                }
            }
            var solutionColor = vessel.get("color").toRgb();
            sketch.attachFunction = function (processing) {
                processing.setup = function() {
                    processing.size(width, height);
                    processing.noStroke();
                    processing.frameRate(50);
                };
                processing.draw = function() {
                    processing.background(solutionColor.r, solutionColor.g, solutionColor.b, 60);
                    for (i = 0; i < particles.length; i++) {
                        var particle = particles[i];
                        particle.x += particle.xDirection;
                        particle.y += particle.yDirection;
                        if (particle.x + particle.r >= width || particle.x - particle.r <= 0) {
                            particle.xDirection *= -1;
                        }
                        if (particle.y + particle.r >= height || particle.y - particle.r <= 0) {
                            particle.yDirection *= -1;
                        }
                        processing.fill(particle.color.r, particle.color.g, particle.color.b);
                        switch (particle.shapeID) {
                            case 0:
                                processing.ellipse(particle.x, particle.y, particle.r, particle.r);
                                break;
                            case 1:
                                processing.rect(particle.x, particle.y, particle.r, particle.r);
                                break;
                            default:
                                processing.triangle(particle.x, particle.y, particle.x + particle.r, particle.y, particle.x + particle.r/2, particle.y + Math.sqrt(3)*particle.r/2);
                        }
                    }
                }.bind(this);
            };
            this.p = new Processing($("#particleCanvas")[0], sketch);
            var zoomOut = $("#particleZoomOut");
            zoomOut.unbind("click");
            zoomOut.on("click", function(){
                this.drawParticleView(logSampleVolume + 1);
            }.bind(this));
            var zoomIn = $("#particleZoomIn");
            zoomIn.unbind("click");
            zoomIn.on("click", function(){
                this.drawParticleView(logSampleVolume - 1);
            }.bind(this));
            var table = $("#particleTable");
            table.html("");
            table.append("<tr><td>"+lang.solutionProperties.volume[language]+" (L)</td><td>10<sup>" + logSampleVolume + "</sup></td></tr>");
            table.append("<tr><td>log("+lang.solutionProperties.volume[language]+" (L))</td><td>" + logSampleVolume + "</td></tr>");
            table.append("<tr><td colspan='2' style='font-weight:bold'>"+lang.particleView.tooMany[language]+"</td></tr>");
            for (i = 0; i < tooMany.length; i++) {
                var sp = tooMany[i];
                if (sp.infinite) {
                    table.append("<tr><td>" + sp.name + "</td><td>&infin;</td></tr>");
                }
                else {
                    table.append("<tr><td>" + sp.name + "</td><td>" + sp.n.toLocaleString(language, {maximumSignificantDigits: 3, minimumSignificantDigits: 3}) + "</td></tr>");
                }
            }
            table.append("<tr><td colspan='2' style='font-weight:bold'>"+lang.particleView.shown[language]+"</td></tr>");
            var shapes = ["&#9711;", "&#9974;", "&#9661;"];
            for (i = 0; i < shown.length; i++) {
                var sp = shown[i];
                table.append("<tr><td style='color:rgb(" + Math.floor(sp.color.r) + "," + Math.floor(sp.color.g) + "," + Math.floor(sp.color.b) + ")'>" + shapes[sp.shapeID] + " " + sp.name + "</td><td>" + Math.floor(sp.n) + "</td></tr>");
            }
            table.append("<tr><td colspan='2' style='font-weight:bold'>"+lang.particleView.tooFew[language]+"</td></tr>");
            for (i = 0; i < tooFew.length; i++) {
                var sp = tooFew[i];
                table.append("<tr><td>" + sp.name + "</td><td>" + sp.n.toLocaleString(language, {maximumSignificantDigits: 3, minimumSignificantDigits: 3}) + "</td></tr>");
            }
        },
        openTrackingOptions: function(){
            this.frozen = true;
            $("#trackVessel").css("display", "none");
            $("#trackingChoices").css("display", "block");
            $("#startTracking").css("display", "block");
        },
        startTracking: function(){
            this.frozen = false;
            this.vessel.set("tracking", true);
            this.vessel.set("timedTracking", $("#timedTracking").is(":checked"));
            this.vessel.set("pourTracking", $("#pourTracking").is(":checked"));
            $("#trackingChoices").css("display", "none");
            $("#startTracking").css("display", "none");
            this.loadTracking();
        },
        loadTracking: function(){
            var takeDataPoint = $("#takeDataPoint");
            takeDataPoint.css("display", "block");
            takeDataPoint.unbind("click");
            takeDataPoint.on("click", function(){
                this.vessel.recordProperties();
            }.bind(this));
            var downloadLog = $("#downloadLog");
            downloadLog.css("display", "block");
            downloadLog.attr("is", "csv-download");
            downloadLog.attr("log", this.formatData(this.vessel.get("log")));
            downloadLog.attr("data", "{{log}}");
            downloadLog.attr("download", this.vessel.get("name") + ".csv");
            downloadLog.attr("href", "data:text/csv," + downloadLog.attr("log"));
        },
        formatData: function(log){
            var formattedLog = JSON.parse(JSON.stringify(log));
            var i;
            for (i = 0; i < formattedLog.length; i++) {
                formattedLog[i][formattedLog[i].length - 1] += "%0D%0A";
            }
            formattedLog.unshift(this.vessel.get("name"));
            return formattedLog;
        },
        openMenu: function(){
            $("#viewerMenu").dropdown();
            this.frozen = true;
        },
        toggleViewer: function(event){
           $(".dropdown-toggle").dropdown("toggle");
            this.frozen = false;
            var viewer = $(event.target).attr("title");
            if (this.viewers[viewer].display === "block") {
                this.viewers[viewer].display = "none";
                this.loadViewers();
            }
            else {
                this.viewers[viewer].display = "block";
                this.loadViewers();
            }
        },
        loadAssignment: function(assignmentToLoad){
            this.assignmentTitle = assignmentToLoad.name;
            this.assignmentText = assignmentToLoad.assignmentText;
            this.render();
        },
        loadViewerConfiguration: function(viewers){
            this.viewers = {
                assignment: {
                    display: "none",
                    name: lang.viewers.assignment[language]
                },
                solutionProperties: {
                    display: "none",
                    name: lang.viewers.solutionProperties[language]
                },
                thermometer: {
                    display: "none",
                    name: lang.viewers.thermometer[language]
                },
                pH: {
                    display: "none",
                    name: lang.viewers.pH[language]
                },
                aqueous: {
                    display: "none",
                    name: lang.viewers.aqueous[language]
                },
                solid: {
                    display: "none",
                    name: lang.viewers.solid[language]
                },
                gas: {
                    display: "none",
                    name: lang.viewers.gas[language]
                },
                conductivity: {
                    display: "none",
                    name: lang.viewers.conductivity[language]
                },
                spectrometer: {
                    display: "none",
                    name: lang.viewers.spectrometer[language]
                },
                particleView: {
                    display: "none",
                    name: lang.viewers.particleView[language]
                },
                vesselTrackingControl: {
                    display: "none",
                    name: lang.viewers.vesselTrackingControl[language]
                }
            };
            this.viewerList = [];
            var i;
            for (i = 0; i < viewers.length; i++) {
                this.viewers[viewers[i].id].display = viewers[i].displayDefault ? "block" : "none";
                this.viewers[viewers[i].id].args = viewers[i].args;
                this.viewerList.push(viewers[i].id);
            }
            this.aqueousUnits = this.viewers.aqueous?.args?.aqUnits ?? 'Molarity' // Default value...
        }
    });
    return InstrumentpanelView;
});
